import React from 'react'
import { VideoLoader } from 'loaders'
import urlConstructor from 'utils/urlConstructor'
import PropTypes from 'prop-types'
import VideoLayout from './VideoLayout'
import CheckNotProcessedVideoSequences from './CheckNotProcessedVideoSequences'

const Video = ({
  match: {
    params: { teamUuid, seasonId, videoId },
  },
  history: { push },
}) => {
  const historySubPush = path => push(urlConstructor(teamUuid, seasonId, path))

  return (
    <VideoLoader
      videoId={videoId}
      additionalFields={['sequences', 'players', 'trainings', 'matches']}
    >
      <CheckNotProcessedVideoSequences videoId={videoId}>
        <VideoLayout historySubPush={historySubPush} />
      </CheckNotProcessedVideoSequences>
    </VideoLoader>
  )
}

Video.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      teamUuid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      seasonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
}

export default Video
